<template>
    <div class="v-dropdown-list" :ref="onRef" @scroll="handleScroll">
        <ul
            :style="{
                height: scrollHeight ? scrollHeight + 'px' : ''
            }"
        >
            <li
                v-for="(item, index) in showOptions"
                class="dropdown-list-li"
                :class="{ virtual: isVirtual }"
                :key="'drop-li' + index"
                :style="{
                    top: item.top ? item.top + 'px' : '',
                    height: itemHeight + 'px'
                }"
                @click="handleClickOption(item)"
            >
                <Node
                    :multiple="multiple"
                    :theme="theme"
                    :label="item.label"
                    :selected="item.selected"
                >
                    <template #default>
                        <slot name="default"></slot>
                    </template>
                </Node>
            </li>
        </ul>
    </div>
</template>
<script>
import Node from './node.vue';
import util from '@/common/util';
import { defineComponent, reactive, ref, nextTick, computed, watch, onMounted } from 'vue';

export default defineComponent({
    components: {
        Node
    },
    emits: ['clickOption'],
    props: {
        multiple: {
            type: Boolean,
            default: false
        },
        options: {
            type: Array,
            default: () => []
        },
        theme: {
            type: String,
            default: 'standard'
        },
        itemHeight: {
            type: Number,
            default: 42
        },
        virtual: {
            type: Boolean,
            default: false
        }
    },
    setup(props, { emit }) {
        const dropdownList = ref(null);

        let state = reactive({
            startIndex: 0,
            listRealHeight: 0
        })

        const isVirtual = computed(() => props.virtual || props.options.length > 50);
        const size = computed(() => state.listRealHeight / props.itemHeight + 2);
        const scrollHeight = computed(() => isVirtual.value ? props.itemHeight * props.options.length + '' : '');

        const showOptions = computed(() => {
            let len = isVirtual.value ? size.value : props.options.length;
            let startIndex = isVirtual.value ? state.startIndex : 0;
            let arr = props.options.slice(startIndex, startIndex + len);
            arr.forEach((item, i) => {
                if (isVirtual.value) {
                    item.top = (startIndex + i) * props.itemHeight;
                } else {
                    delete item.top;
                }
            });
            return arr;
        })

        const getDropListHeight = () => {
            nextTick(() => {
                if (!dropdownList.value) {
                    return; 
                }
                state.listRealHeight = parseInt(
                    window.getComputedStyle(dropdownList.value).height
                );
            });
        }
        const handleScroll = util.throttle(function(event) {
            if (isVirtual.value) {
                let { scrollTop } = event.target;
                state.startIndex = Math.floor(scrollTop / props.itemHeight);
            }
        }, 16)
        const handleClickOption = (item) => emit('clickOption', item)

        watch(() => props.options, getDropListHeight);
        const onRef = (e) => {
            dropdownList.value = e;
        };

        onMounted(() => {
            getDropListHeight()
        });

        return {
            onRef,
            isVirtual,
            scrollHeight,
            showOptions,
            handleScroll,
            handleClickOption
        }
    }
});
</script>
<style lang="scss">
@import '@/theme/mixin.scss';
.v-dropdown-list {
    height: 100%;
    position: relative;
    overflow: auto;
    .dropdown-list-li {
        padding: 0px 10px;
        color: var(--g-text-color);
        cursor: pointer;
        @include color-button-hover();
        &.multiple {
            padding: 0px;
        }
        &.multiple:hover {
            background-color: transparent;
        }
        &.selected {
            color: #4c84ff;
        }
        &.virtual {
            position: absolute;
            right: 2px;
            left: 2px;
        }
    }
}

.v-dropdown-list::-webkit-scrollbar {
    width: 0 !important;
}
</style>
